import './config/env-stage-setup'

import { StrictMode } from 'react'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom'

import App from './App'
import config from './config/app-config'
import reportWebVitals from './reportWebVitals'

const isProduction = __PROD__
const isStaging = __STAGING__

Sentry.init({
  dsn: config?.sentryDSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    ...(isProduction ? [Sentry.replayIntegration()] : []),
  ],
  // Error sampling: lower on staging to avoid 429s
  sampleRate: isProduction ? 1.0 : 0.2,
  // Performance Monitoring: lower on staging
  tracesSampleRate: isProduction ? 0.5 : 0.1,
  tracePropagationTargets: [
    'https://api.databiologics.com',
    'https://staging-api.databiologics.com',
  ],
  // Session Replay: production only (replay is the main cause of 429s)
  replaysSessionSampleRate: isProduction ? 0.1 : 0,
  replaysOnErrorSampleRate: isProduction ? 1.0 : 0,
  environment: `provider-${process.env.REACT_APP_STAGE}`,
  enabled: isProduction || isStaging,
})

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
